<script setup lang="ts">
import { relinkLogos } from "~/assets/images/relink/assets";

defineProps<{
  inverted?: boolean;
}>();

const logo = relinkLogos[0];
</script>

<template>
  <img
    class="relink-logo"
    :class="{ 'relink-logo--inverted': inverted }"
    :src="logo.src"
    :alt="logo.alt"
  />
</template>

<style scoped lang="scss">
.relink-logo {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 1294 / 500;
  object-fit: contain;
}

.relink-logo--inverted {
  filter: brightness(0) invert(1);
}
</style>
